"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Review = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const Flex_1 = require("@amzn/atoz-web/Flex");
const Text_1 = require("@amzn/atoz-web/Text");
const Hr_1 = require("@amzn/atoz-web/Hr");
const View_1 = require("@amzn/atoz-web/View");
const logger_1 = require("../../../../logger");
const SpinnerOverlay_1 = require("../../../../components/SpinnerOverlay");
const context_1 = require("../../context");
const PunchWorkflowTypes_1 = require("../../PunchWorkflowTypes");
const DateManagement_1 = require("../../../../utils/DateManagement/DateManagement");
const utils_1 = require("../../../../utils");
const Review = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { action, selectedPunchTime, newPunchTime, newPunchDate, isSubmitting, useMilitaryTime, setIsActionable, setIsCurrentStepValid, setCurrentStepTitle } = (0, context_1.usePunchWorkflowContext)();
    const { ADD, DELETE, EDIT } = PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS;
    (0, react_1.useEffect)(() => {
        utils_1.BIAnalytics.arriveReviewInPW();
        setCurrentStepTitle(t('time_and_attendance_PunchWorkflow_ReviewStep_Title'));
        setIsActionable(true);
        setIsCurrentStepValid(true);
    }, []);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_WORKFLOW_REVIEW_STEP_RENDERED.COUNT
        },
        isComponentLoaded: true
    });
    return (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: 'PunchWorkflowReview' },
        react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isSubmitting },
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                action && [DELETE, EDIT].includes(action) && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column' },
                    react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, action == EDIT
                        ? t('time_and_attendance_PunchWorkflow_ReviewStep_PunchEdited')
                        : t('time_and_attendance_PunchWorkflow_ReviewStep_PunchDeleted')),
                    react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, t('time_and_attendance_DateAtTime', {
                        date: luxon_1.DateTime.fromISO(selectedPunchTime.punchDateTime.timestamp).toFormat('LLLL dd, yyyy'),
                        time: luxon_1.DateTime.fromISO(selectedPunchTime.punchDateTime.timestamp).toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
                    })))),
                action && [ADD, EDIT].includes(action) && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column' },
                    react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, action == EDIT
                        ? t('time_and_attendance_PunchWorkflow_ReviewStep_NewPunchTime')
                        : t('time_and_attendance_PunchWorkflow_ReviewStep_PunchAdded')),
                    react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, t('time_and_attendance_DateAtTime', {
                        date: newPunchDate.toFormat('LLLL dd, yyyy'),
                        time: (0, DateManagement_1.parsePunchTime)(newPunchTime, newPunchDate, useMilitaryTime).toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
                    }))))),
            react_1.default.createElement(View_1.View, { margin: { top: 'S400' } },
                react_1.default.createElement(Hr_1.Hr, null)))));
};
exports.Review = Review;
